import React, { useContext } from "react"
import { Tabs, TabList, Button, Tab, Text, Box, TabPanels, TabIndicator, TabPanel, VStack } from "@chakra-ui/react"
import Order, { OrderTitle } from "./Order"
import { useQuery } from "react-query";
import { getOrders } from "../../services/orders"
import { OrderSkeleton } from "./Order";
import { AdminContext } from "../../contexts/AdminContext";
import EmptyState from "../products/EmptyState";

const OrdersTab: React.FC = () => {
  const { admin } = useContext(AdminContext)
  const token = `bearer ${admin.token}`

  const placed_orders = useQuery('placed_orders', () => getOrders(token, 'placed'))
  const confirmed_orders = useQuery('confirmed_orders', () => getOrders(token, 'confirmed'))
  const ofd_orders = useQuery('ofd_orders', () => getOrders(token, 'outForDelivery'))
  const completed_orders = useQuery('completed_orders', () => getOrders(token, 'completed'))
  const canceled_orders = useQuery('canceled_orders', () => getOrders(token, 'canceled'))

  return (
    <Tabs>
      <TabList color='gray.500'>
        <Tab _selected={{ color: '#37A75B' }}>
          <Text
            display={['block', 'none']}
            fontSize={['xs', 'xs', 'md']} fontWeight='semibold'
          >
            Plcd
          </Text>

          <Text
            display={['none', 'block']}
            fontSize={['xs', 'xs', 'md']} fontWeight='semibold'
          >
            Placed
          </Text>
        </Tab>

        <Tab _selected={{ color: '#37A75B' }}>
          <Text
            display={['block', 'none']}
            fontSize={['xs', 'xs', 'md']} fontWeight='semibold'
          >
            Conf
          </Text>

          <Text
            display={['none', 'block']}
            fontSize={['xs', 'xs', 'md']} fontWeight='semibold'
          >
            Confirmed
          </Text>
        </Tab>

        <Tab _selected={{ color: '#37A75B' }}>
          <Text
            display={['block', 'none']}
            fontSize={['xs', 'xs', 'md']} fontWeight='semibold'
          >
            O.F.D
          </Text>

          <Text
            display={['none', 'block']}
            fontSize={['xs', 'xs', 'md']} fontWeight='semibold'
          >
            Out for delivery
          </Text>
        </Tab>

        <Tab _selected={{ color: '#37A75B' }}>
          <Text
            display={['block', 'none']}
            fontSize={['xs', 'xs', 'md']} fontWeight='semibold'
          >
            Compltd
          </Text>

          <Text
            display={['none', 'block']}
            fontSize={['xs', 'xs', 'md']} fontWeight='semibold'
          >
            Completed
          </Text>
        </Tab>

        <Tab _selected={{ color: '#37A75B' }}>
          <Text
            display={['block', 'none']}
            fontSize={['xs', 'xs', 'md']} fontWeight='semibold'
          >
            Cncld
          </Text>

          <Text
            display={['none', 'block']}
            fontSize={['xs', 'xs', 'md']} fontWeight='semibold'
          >
            Canceled
          </Text>
        </Tab>
      </TabList>

      <TabIndicator
        mt="-1.5px"
        height="2px"
        bg="#37A75B"
        borderRadius="1px"
      />

      <TabPanels>
        <TabPanel p={0}>
          <Box w='100%'>
            {placed_orders.data &&
              placed_orders.data.length > 0 &&
                <Box>
                  <OrderTitle />

                  <Box>
                    {placed_orders.data.map((order: any) => (
                      <Order key={order._id} order={order} />
                    ))}
                  </Box>
                </Box>
            }

            {placed_orders.data &&
              placed_orders.data.length < 1 &&
                <Box mt='10'>
                  <EmptyState 
                    message="No placed orders available"
                  />
                </Box>
            }

            {placed_orders.isLoading &&
              <VStack mt='10' align='stretch'>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num: any) => (
                  <OrderSkeleton key={num} />
                ))}
              </VStack>
            }

            {placed_orders.isError &&
              <Box textAlign='center' mt='10'>
                <Text
                  p='2' color='red.500'
                  fontWeight='semibold'
                >
                  Failed to fetch Orders
                </Text>

                <Button colorScheme='green' size='lg' onClick={() => placed_orders.refetch()}>
                  Try again
                </Button>
              </Box>
            }
          </Box>
        </TabPanel>

        <TabPanel p={0}>
          <Box w='100%'>
            {confirmed_orders.data &&
              confirmed_orders.data.length > 0 &&
              <Box>
                <OrderTitle />

                <Box>
                  {confirmed_orders.data.map((order: any) => (
                    <Order key={order._id} order={order} />
                  ))}
                </Box>
              </Box>
            }

            {confirmed_orders.data &&
              confirmed_orders.data.length < 1 &&
              <Box mt='10'>
                <EmptyState 
                  message="No confirmed orders available"
                />
              </Box>
            }

            {confirmed_orders.isLoading &&
              <VStack mt='10' align='stretch'>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num: any) => (
                  <OrderSkeleton key={num} />
                ))}
              </VStack>
            }

            {confirmed_orders.isError &&
              <Box textAlign='center' mt='10'>
                <Text
                  p='2' color='red.500'
                  fontWeight='semibold'
                >
                  Failed to fetch Orders
                </Text>

                <Button colorScheme='green' size='lg' onClick={() => confirmed_orders.refetch()}>
                  Try again
                </Button>
              </Box>
            }
          </Box>
        </TabPanel>

        <TabPanel p={0}>
          <Box w='100%'>
            {ofd_orders.data &&
              ofd_orders.data.length > 0 &&
              <Box>
                <OrderTitle />

                <Box>
                  {ofd_orders.data.map((order: any) => (
                    <Order key={order._id} order={order} />
                  ))}
                </Box>
              </Box>
            }

            {ofd_orders.data &&
              ofd_orders.data.length < 1 &&
              <Box mt='10'>
                <EmptyState 
                  message="No out for delivery orders available"
                />
              </Box>
            }

            {ofd_orders.isLoading &&
              <VStack mt='10' align='stretch'>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num: any) => (
                  <OrderSkeleton key={num} />
                ))}
              </VStack>
            }

            {ofd_orders.isError &&
              <Box textAlign='center' mt='10'>
                <Text
                  p='2' color='red.500'
                  fontWeight='semibold'
                >
                  Failed to fetch Orders
                </Text>

                <Button colorScheme='green' size='lg' onClick={() => ofd_orders.refetch()}>
                  Try again
                </Button>
              </Box>
            }
          </Box>
        </TabPanel>

        <TabPanel p={0}>
          <Box w='100%'>
            {completed_orders.data &&
              completed_orders.data.length > 0 &&
              <Box>
                <OrderTitle />

                <Box>
                  {completed_orders.data.map((order: any) => (
                    <Order key={order._id} order={order} />
                  ))}
                </Box>
              </Box>
            }

            {completed_orders.data &&
              completed_orders.data.length < 1 &&
              <Box mt='10'>
                <EmptyState 
                  message="No completed orders available"
                />
              </Box>
            }

            {completed_orders.isLoading &&
              <VStack mt='10' align='stretch'>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num: any) => (
                  <OrderSkeleton key={num} />
                ))}
              </VStack>
            }

            {completed_orders.isError &&
              <Box textAlign='center' mt='10'>
                <Text
                  p='2' color='red.500'
                  fontWeight='semibold'
                >
                  Failed to fetch Orders
                </Text>

                <Button colorScheme='green' size='lg' onClick={() => completed_orders.refetch()}>
                  Try again
                </Button>
              </Box>
            }
          </Box>
        </TabPanel>

        <TabPanel p={0}>
          <Box w='100%'>
            {canceled_orders.data &&
              canceled_orders.data.length > 0 &&
              <Box>
                <OrderTitle />

                <Box>
                  {canceled_orders.data.map((order: any) => (
                    <Order key={order._id} order={order} />
                  ))}
                </Box>
              </Box>
            }

            {canceled_orders.data &&
              canceled_orders.data.length < 1 &&
              <Box mt='10'>
                <EmptyState 
                  message="No canceled orders available"
                />
              </Box>
            }

            {canceled_orders.isLoading &&
              <VStack mt='10' align='stretch'>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num: any) => (
                  <OrderSkeleton key={num} />
                ))}
              </VStack>
            }

            {canceled_orders.isError &&
              <Box textAlign='center' mt='10'>
                <Text
                  p='2' color='red.500'
                  fontWeight='semibold'
                >
                  Failed to fetch Orders
                </Text>

                <Button colorScheme='green' size='lg' onClick={() => canceled_orders.refetch()}>
                  Try again
                </Button>
              </Box>
            }
          </Box>
        </TabPanel>
      </TabPanels>
    </Tabs>
  )
}

export default OrdersTab